import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "center",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    return {
      userData: {
        nickname: {
          label: "Nickname"
        },
        gender: {
          label: "Gender"
        },
        birthday: {
          label: "Birthday"
        },
        country: {
          label: "Country"
        },
        profession: {
          label: "Profession"
        }
      },
      popPromptShow: false,
      popPromptInfo: {
        title: null,
        reward: null
      },
      selectKey: null,
      userdataInput: "",
      countryList: null,
      popCountryShow: false,
      popBenefitsShow: false
    };
  },
  watch: {
    popPromptShow: {
      handler(bool) {
        if (!bool) {
          if (this.popPromptInfo && this.popPromptInfo.isConfirmLoading) {}
          this.userdataInput = "";
          this.selectKey = null;
          this.popPromptInfo = {
            title: null,
            reward: null
          };
        }
      }
    },
    isLogin: {
      async handler(bool) {
        if (bool) {
          this.countryList = await this.getCountryData();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["updataUserData", "getCountryData", "getUserRights"]),
    ...userVuex.mapMutations(["setUserInfo"]),
    async onEditUserData(value, key) {
      this.selectKey = {
        title: key,
        isEdit: this.userInfo[`${key}_edit`],
        value: this.userInfo[key],
        label: value.label
      };
      if (this.selectKey.value !== null) {
        if (this.selectKey.title == "birthday") {
          this.userdataInput = this.fmt_time(this.selectKey.value).format("YYYY-MM-DD");
        } else {
          this.userdataInput = this.selectKey.value;
        }
      }
      console.log("this.userdataInput", this.userdataInput);
      const popPromptInfo = {
        title: this.selectKey.label,
        reward: this.selectKey.isEdit <= 0 ? `<img src="${require(`@images/${this.aiSkin}/icon-coin.png`)}" alt="" /> +${this.fmt_pre(100)}</i>` : null,
        confirmText: !this.selectKey.value || this.selectKey.title == "gender" && this.selectKey.value == -1 ? "Submit" : "Edit",
        isConfirmLoading: false,
        confirmFn: async () => {
          console.log("this.selectKey.value111", this.selectKey.value, this.userdataInput);
          if (this.userdataInput === "" || this.selectKey.title == "gender" && this.userdataInput == -1) {
            this.$toasted.clear();
            this.$toasted.info(`Please ${this.selectKey.title == "gender" || this.selectKey.title == "birthday" ? "select" : "enter"} ${this.selectKey.title}`);
            return;
          }
          if (this.selectKey.value != null && (this.selectKey.value == this.userdataInput || this.selectKey.title == "birthday" && this.fmt_time(this.selectKey.value).format("YYYY-MM-DD") == this.userdataInput)) {
            this.$toasted.clear();
            this.$toasted.info(`${this.selectKey.title} has not changed!`);
            return;
          }
          if (key === "country" && !this.countryList) {
            this.countryList = await this.getCountryData();
          }
          this.popPromptInfo.isConfirmLoading = true;
          const res = await this.updataUserData({
            field: this.selectKey.title,
            value: String(this.userdataInput)
          });
          if (!res) {
            this.popPromptInfo.isConfirmLoading = false;
            return;
          }
          const oldCoin = this.userInfo.coin;
          const newCoin = res.coin;
          this.taskInfo.popCoinAnim.userInfo = res;
          this.popPromptInfo.isConfirmLoading = false;
          this.popPromptShow = false;
          if (oldCoin != newCoin) {
            await new Promise(resolve => setTimeout(resolve, 500));
            this.taskInfo.popCoinAnim.reward = 100;
            this.taskInfo.popCoinAnim.show = true;
          } else {
            this.setUserInfo(res);
          }
        }
      };
      this.popPromptInfo = popPromptInfo;
      this.popPromptShow = true;
    },
    onInput() {
      console.log("this.userdataInput", this.userdataInput);
    },
    onDateInputClick(e) {
      const target = e.target;
      target.readOnly = false;
      try {
        target.showPicker?.();
      } catch (e) {
        target.focus();
        target.click();
      }
      setTimeout(() => {
        target.readOnly = true;
      }, 200);
    },
    onCountryAnchor(item) {
      this.$nextTick(() => {
        const xx = document.getElementById(item);
        const countryListRef = this.$refs.countryListRef;
        countryListRef.scrollTop = xx.offsetTop;
        console.dir(xx);
        console.dir(countryListRef);
      });
    },
    onSelectCountry(item) {
      this.userdataInput = item.name;
      this.popCountryShow = false;
    },
    showCountry() {
      this.popCountryShow = true;
      if (this.userdataInput) {
        setTimeout(() => {
          const firstLetter = this.userdataInput[0].toUpperCase();
          console.log("firstLetterfirstLetter", firstLetter);
          this.onCountryAnchor(firstLetter);
        }, 500);
      }
    }
  }
};